import { Dayjs } from 'dayjs';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { AuditLogEntry } from './audit-log-entry.js';
import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';

export class AuditLogEntryDto extends DataModel {
  static readonly TYPE_ID: string = '23498bd319a147b1bcf8630a8fddb0b8';

  private constructor(
    public readonly uniqueId: string,
    public readonly creationDate: Dayjs,
    public readonly data: AuditLogEntry,
  ) {
    super();
  }

  get $typeId(): string {
    return AuditLogEntryDto.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    creationDate: Dayjs,
    data: AuditLogEntry,
  }): AuditLogEntryDto {
    return new AuditLogEntryDto(
        args.uniqueId,
        args.creationDate,
        args.data,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AuditLogEntryDto {
    return this.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      creationDate: context.decodeDate(MapUtils.getNumber(map, 'creationDate')),
      data: context.fromData(MapUtils.getRecord(map, 'data')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      creationDate: context.encodeDate(this.creationDate),
      type: fromEnumAsString(this.data.type),
      data: context.toData(this.data),
    };
  }

  clone(): this {
    return AuditLogEntryDto.create({
      uniqueId: this.uniqueId,
      creationDate: this.creationDate,
      data: this.data.clone(),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      other.creationDate === this.creationDate &&
      isSameData(other.data, this.data);
  }
}

export class AuditLogEntryDtoBuilder extends DataModelBuilder<AuditLogEntryDto> {
  build(context: SerializationContext, map: SerializedData): AuditLogEntryDto {
    return AuditLogEntryDto.fromMap(context, map);
  }

  optimizeForQuery(context: SerializationContext, model: AuditLogEntryDto): SerializedData | null {
    return model.data.generateQueryData();
  }
}
